<template>
  <b-modal
    id="translate-modal"
    title="Translate site"
    class="custom-sm-modal"
    hide-backdrop
    scrollable
    hide-footer
  >
    <!-- <v-google-translate
      @select="languageSelectedHandler"
      :languages="countryList"
      :showArrow="false"
    /> -->
    <!--  
    <v-google-translate
      :showArrow="false"
      @select="languageSelectedHandler"
      :languages="countryList2"
    /> -->

    <!-- </div> -->
    <CGTranslator :countries="countries" @click="hideModal" />
  </b-modal>
</template>

<script>
import { Translator } from "vue-google-translate";
import CGTranslator from "./GoogleTranslater.vue";

export default {
  name: "TranslateModal",

  components: {
    Translator,
    CGTranslator,
  },

  data() {
    return {
      checkbox1: false,
      checkbox2: false,
      defaultLanguageCode: "en",
      defaultPageLanguageCode: "en",
      countryList: [
        {
          code: "en",
          name: "English",
          cname: "英语",
          ename: "English",
        },
        {
          code: "hi",
          name: "Hindi",
          cname: "印地语",
          ename: "Hindi",
        },
      ],
      countryList2: [
        // {
        //   code: "en",
        //   name: "English",
        //   cname: "英语",
        //   ename: "English",
        // },
        {
          code: "hi",
          name: "Hindi",
          cname: "印地语",
          ename: "Hindi",
        },
      ],
      countries: [
        {
          code: "en|hi",
          title: "हिन्दी",
          flagIconUrl: "https://flagicons.lipis.dev/flags/4x3/in.svg",
          altText: "Hindi language translation",
        },
        {
          code: "en|en",
          title: "English",
        },
        // {
        //   code: "en|zh-CN",
        //   title: "Chinese (Simplified)",
        // },
        // {
        //   code: "en|es",
        //   title: "Spanish",
        // },

        // {
        //   code: "en|fr",
        //   title: "French",
        // },
        // {
        //   code: "en|ja",
        //   title: "Japanese",
        // },
        // {
        //   code: "en|pt",
        //   title: "Portuguese",
        //   flagIconUrl: "https://flagicons.lipis.dev/flags/4x3/pt.svg",
        //   altText: "Portuguese language translation",
        // },

        // {
        //   code: "en|de",
        //   title: "German",
        // },
        // {
        //   code: "en|ko",
        //   title: "Korean",
        // },
        // {
        //   code: "en|ar",
        //   title: "Arabic",
        // },
      ],
      hindi: [
        {
          code: "en|hi",
          title: "Hindi",
          flagIconUrl: "https://flagicons.lipis.dev/flags/4x3/in.svg",
          altText: "Hindi language translation",
        },
      ],
      english: [
        {
          code: "en|en",
          title: "English",
          flagIconUrl: "https://flagicons.lipis.dev/flags/4x3/gb.svg",
        },
      ],
    };
  },
  watch: {
    checkbox1(newVal) {
      if (newVal) this.checkbox2 = false;
    },
    checkbox2(newVal) {
      if (newVal) this.checkbox1 = false;
    },
  },

  methods: {
    changeVal() {
      let selectedLang = localStorage.getItem("selectedLang");
      if (selectedLang === "hindi") {
        this.checkbox1 = true;
        this.checkbox2 = false;
      } else if (selectedLang === "eng") {
        this.checkbox2 = true;
        this.checkbox1 = false;
      }
    },
    setLang(val) {
      localStorage.setItem("selectedLang", val);
    },
    languageSelectedHandler(info) {
      // console.log(info);
    },
    hideModal(data) {
      // console.log(data);
      this.$bvModal.hide("translate-modal");
    },
  },
  mounted() {
    // let selectedLang = localStorage.getItem("selectedLang");
    // if (selectedLang === "hindi") {
    //   let myLang = document.getElementById(selectedLang);
    //   myLang.style.border = "8px solid #4f0a4b";
    //   myLang.style.cursor = "not-allowed";
    // } else if (selectedLang === "eng") {
    //   let myLang = document.getElementById(selectedLang);
    //   myLang.style.border = "8px solid #4f0a4b";
    //   myLang.style.cursor = "not-allowed";
    // }
  },
};
</script>
<style>
#translate-modal .modal-dialog {
  max-width: 300px !important;
  margin: 1.75rem auto;
}

#translate-modal .modal-content {
  max-height: 200px !important;
  overflow-y: hidden;
}
</style>